import { ChildFragmentFragment } from "@outschool/gql-frontend-generated";
import { dayjs } from "@outschool/time";
import { CurrentUser } from "@outschool/ui-auth";

export type LearnerInfo = NonNullable<CurrentUser>["children"][0] | null;

/**
 * example:
 * This is a class recommendation request.
 * --- Learner Info ---
 * Name: John
 * Age: 10
 * Pronoun: He/Him
 * schooling_approach: "homeschool"
 * Availability: Monday 10:00 AM - 11:00 AM
 * --- Parent Message ---
 * I need help with math homework.
 */
export function buildUserMessage(
  inputValue: string,
  selectedLearner: ChildFragmentFragment | LearnerInfo | undefined
) {
  let contextPrefix = "This is a class recommendation request.\n";
  let userMessage = inputValue;
  if (selectedLearner) {
    contextPrefix += `--- Learner Info ---\nName: ${selectedLearner.name}\n`;
    if (selectedLearner.age) {
      contextPrefix += `Age: ${selectedLearner.age}\n`;
    }
    if (selectedLearner.pronoun) {
      contextPrefix += `Pronoun: ${selectedLearner.pronoun}\n`;
    }
    selectedLearner.attributes
      .filter(attribute => attribute.value !== "")
      .forEach(attribute => {
        contextPrefix += `${attribute.key}: ${attribute.value}\n`;
      });
    selectedLearner.entityAvailabilitySchedule?.entityAvailabilities.forEach(
      availability => {
        const dayString = dayjs().day(availability.day).format("dddd");
        const startTimeString = dayjs()
          .hour(availability.startHour)
          .minute(availability.startMinute)
          .format("h:mm a");
        const endTimeString = dayjs()
          .hour(availability.endHour)
          .minute(availability.endMinute)
          .format("h:mm a");
        contextPrefix += `Availability: ${dayString} ${startTimeString} - ${endTimeString}\n`;
      }
    );

    contextPrefix += "--- Parent Message --- \n";
  }
  return contextPrefix + userMessage;
}
